import axios from 'axios';
import { useEffect, useState } from 'react';
import { app } from '../config';
let url = `${app.URL}/org/fetchall`;
const useFetchUsers = () => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    async function fetchData(){
      try {
        const res = await axios.get(`${app.URL}/user/getusers`);
        setResponse(res.data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };
       fetchData();
  }, []);
  return { loading, response, error };
};

export default useFetchUsers;
